<template>
  <div
    v-if="showWaitingTime"
    class="flex justify-end">
    <div
      class="q-mt-xs fs-14 cursor-pointer"
      @click="onClick"
    >
      <span v-html="$t('label.min_waiting', { min: increasedWaitingTime })" />
      <q-icon
        name="info"
        size="16px"
        class="q-ml-4"
      />
    </div>

    <Modal
      v-model="showWaitingTimeModal"
      :title="$t('label.free_waiting_details')"
    >
      <div class="q-px-16 q-pb-24">
        <div class="q-mb-24 q-pl-20">
          <div
            v-for="item in $tm('label.waiting_time')"
            :key="item"
            v-html="item"
          />
        </div>
        <GtBtn
          :label="$t('button.ok')"
          class="full-width"
          @click="showWaitingTimeModal = false"
        />
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { computed, ref, inject } from 'vue';
import GtBtn from '~components/GtBtn';
import Modal from '~components/Modal';
import { useConfigsStore } from '~stores/configs';

const props = defineProps({
  point: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    default: null,
  },
});

const moment = inject('moment');

const configsStore = useConfigsStore();

const showWaitingTimeModal = ref(false);

const increasedWaitingTime = computed(() => {
  if (hasType('airport')) return 60;
  if (hasType('train_station')) return 30;
  return null;
});

const showWaitingTime = computed(() => {
  if (!configsStore.configs.show_waiting_time_on_transfer_form) return false;
  if (!increasedWaitingTime.value) return false;
  const diff = moment(props.date).diff(undefined, 'minutes');

  return diff > 30;
});

function hasType(type) {
  return props.point.types?.includes(type);
}

function onClick() {
  showWaitingTimeModal.value = true;
  window.$logEvent?.firebase('show_free_waiting_modal');
}
</script>
